export default "__VITE_ASSET__DtdVenha__"